export default function AppEntry() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-96 h-96 bg-accent-500/10 rounded-full blur-3xl -translate-y-1/3 translate-x-1/3"></div>
          <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">随时随地，掌上吃瓜</h2>
              <p className="mt-3 text-white/70 text-sm md:text-base leading-relaxed max-w-lg">
                关注网红黑料官方账号，第一时间获取最新网红黑料情报。移动端浏览体验全面优化，地铁上、排队时都能轻松吃瓜。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-5">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 bg-white text-foreground-900 font-medium text-sm px-5 py-2.5 rounded-lg hover:bg-accent-50 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line text-lg"></i>
                  手机版访问
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 border border-white/30 text-white font-medium text-sm px-5 py-2.5 rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-notification-3-line text-lg"></i>
                  开启推送通知
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 h-64 md:w-56 md:h-72 bg-foreground-800 rounded-2xl border border-foreground-700 overflow-hidden">
                <div className="absolute inset-0 flex flex-col">
                  <div className="h-10 bg-foreground-950/50 flex items-center px-4">
                    <span className="text-xs text-white/80 font-medium">网红黑料 · 快讯</span>
                  </div>
                  <div className="flex-1 p-3 space-y-2 overflow-hidden">
                    {[1, 2, 3, 4].map((n) => (
                      <div key={n} className="flex items-start gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-1.5 flex-shrink-0"></span>
                        <span className="text-[10px] text-white/60 leading-relaxed line-clamp-2">
                          {n === 1 && '某千万粉博主被曝数据造假...'}
                          {n === 2 && '知名网红深夜发长文道歉...'}
                          {n === 3 && '直播带货新规即将出台...'}
                          {n === 4 && 'MCN机构霸王条款再引争议...'}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}